module.exports = __webpack_public_path__ + "img/zhengfu-link.3a9e0f52.jpg";